var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Left"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M12.5001 1.99609C16.55 1.99609 19.8568 5.19084 19.9959 9.24515L20.0001 9.49609V13.5931L21.3801 16.7491C21.4492 16.907 21.4848 17.0775 21.4848 17.2499C21.4848 17.9402 20.9252 18.4999 20.2348 18.4999L15.5001 18.5014C15.5001 20.1582 14.157 21.5014 12.5001 21.5014C10.9024 21.5014 9.59645 20.2524 9.5052 18.6776L9.49966 18.4991L4.77498 18.4999C4.60364 18.4999 4.43413 18.4646 4.27697 18.3964C3.64377 18.1213 3.35342 17.3851 3.62846 16.7519L5.00011 13.594V9.49599C5.00071 5.3412 8.3522 1.99609 12.5001 1.99609ZM13.9997 18.4991L11.0001 18.5014C11.0001 19.3298 11.6717 20.0014 12.5001 20.0014C13.2798 20.0014 13.9206 19.4065 13.9932 18.6458L13.9997 18.4991ZM12.5001 3.49609C9.17995 3.49609 6.50059 6.17035 6.50011 9.49609V13.9057L5.15613 16.9999H19.8526L18.5001 13.9067L18.5002 9.50895L18.4965 9.28375C18.3854 6.05027 15.7417 3.49609 12.5001 3.49609Z",
    fill: "#49484D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.fffd17eda299ac68383c899580585aa5.svg";
export { ForwardRef as ReactComponent };